module.exports = __webpack_public_path__ + "img/76244.778e3c3d.svg";